<!-- src/components/Group491.vue -->
<template>
  <div :class="[
    'group-491-2',
    { 'group-491--header': variant === 'header' }
  ]">
    <div class="group-235">
      <!-- Аватар или placeholder -->
      <img
        v-if="userAvatar"
        class="image-12-1"
        :src="userAvatar"
        :alt="`Аватар ${userName}`"
        @error="handleImageError"
      />
      <svg 
        v-else
        class="avatar-placeholder"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        fill="currentColor"
        role="img"
        :aria-label="`Аватар ${userName}`"
      >
        <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"/>
      </svg>
    </div>
    
    <span 
      v-if="showName"
      class="text-370 poppins-medium-black-17px"
    >
      {{ displayName }}
    </span>
    
    <button
      v-if="showDropdownArrow"
      type="button"
      class="text-371"
      @click.stop="handleToggle"
      :aria-label="isOpen ? 'Закрыть меню' : 'Открыть меню'"
      :aria-expanded="isOpen"
    >
      <svg
        :class="['dropdown-arrow', { 'dropdown-arrow--open': isOpen }]"
        width="14"
        height="14"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        role="presentation"
      >
        <path
          d="M5.70711 9.71069C5.31658 10.1012 5.31658 10.7344 5.70711 11.1249L10.5993 16.0123C11.3805 16.7927 12.6463 16.7924 13.4271 16.0117L18.3174 11.1213C18.708 10.7308 18.708 10.0976 18.3174 9.70708C17.9269 9.31655 17.2937 9.31655 16.9032 9.70708L12.7176 13.8927C12.3271 14.2833 11.6939 14.2832 11.3034 13.8927L7.12132 9.71069C6.7308 9.32016 6.09763 9.32016 5.70711 9.71069Z"
          fill="currentColor"
        />
      </svg>
    </button>
  </div>
</template>

<script>
export default {
  name: 'Group491',
  
  props: {
    isOpen: {
      type: Boolean,
      default: false
    },
    userName: {
      type: String,
      default: 'Пользователь'
    },
    userAvatar: {
      type: String,
      default: null
    },
    variant: {
      type: String,
      default: 'default',
      validator: value => ['default', 'header'].includes(value)
    },
    showName: {
      type: Boolean,
      default: true
    },
    showDropdownArrow: {
      type: Boolean,
      default: true
    },
    maxNameLength: {
      type: Number,
      default: 20
    }
  },
  
  emits: ['toggle-dropdown', 'avatar-click'],
  
  data() {
    return {
      imageError: false
    }
  },
  
  computed: {
    displayName() {
      if (!this.userName) return 'Пользователь'
      
      // Обрезаем имя если слишком длинное
      if (this.userName.length > this.maxNameLength) {
        return this.userName.substring(0, this.maxNameLength - 3) + '...'
      }
      
      return this.userName
    }
  },
  
  methods: {
    handleToggle() {
      this.$emit('toggle-dropdown')
    },
    
    handleAvatarClick() {
      this.$emit('avatar-click')
    },
    
    handleImageError() {
      this.imageError = true
      console.warn('Failed to load avatar image:', this.userAvatar)
    }
  },
  
  watch: {
    userAvatar(newVal) {
      if (newVal) {
        this.imageError = false
      }
    }
  }
}
</script>

<style scoped>
/* Стили для dropdown стрелки */
.text-371 {
  cursor: pointer;
  user-select: none;
  display: flex;
  align-items: center;
  justify-content: center;
  background: none;
  border: none;
  padding: 4px;
  border-radius: 4px;
  transition: background-color 0.2s ease;
}

.text-371:hover {
  background-color: rgba(0, 0, 0, 0.04);
}

.text-371:focus-visible {
  outline: 2px solid var(--primary-color, #007bff);
  outline-offset: 2px;
}

.dropdown-arrow {
  transition: transform 0.2s ease;
  color: #333;
}

.dropdown-arrow--open {
  transform: rotate(180deg);
}

.text-371:hover .dropdown-arrow {
  transform: scale(1.2);
}

.text-371:hover .dropdown-arrow--open {
  transform: scale(1.2) rotate(180deg);
}

/* Placeholder для аватара */
.avatar-placeholder {
  width: 60%;
  height: 60%;
  color: #888;
}

/* Переход для аватара при ошибке загрузки */
.image-12-1 {
  transition: opacity 0.3s ease;
}

.image-12-1[src=""],
.image-12-1:not([src]) {
  opacity: 0;
}
</style>

<style>
/* Оригинальные глобальные стили для обратной совместимости */
.group-491-2,
.group-491-3,
.group-491-4,
.group-491-5,
.group-491-6,
.group-491-7,
.group-491-8,
.group-491-9,
.group-491-10,
.group-491-11,
.group-491-12,
.group-491-13,
.group-491-14,
.group-491-15,
.group-491-16 {
  height: 50px;
  position: relative;
  min-width: 132px;
  display: flex;
  align-items: center;
  gap: 12px;
  margin-left: 40px;
}

.group-235,
.group-235-1,
.group-235-2,
.group-235-3,
.group-235-4,
.group-235-5,
.group-235-6,
.group-235-7,
.group-235-8,
.group-235-9,
.group-235-10,
.group-235-11,
.group-235-12,
.group-235-13,
.group-235-14 {
  aspect-ratio: 1;
  background-color: #e0e0e0;
  border-radius: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 50px;
  width: 50px;
  flex-shrink: 0;
  overflow: hidden;
  cursor: pointer;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.group-235:hover {
  transform: scale(1.05);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}

.image-12-1,
.image-12-2,
.image-12-3,
.image-12-4,
.image-12-5,
.image-12-6,
.image-12-7,
.image-12-8,
.image-12-9,
.image-12-10,
.image-12-11,
.image-12-12,
.image-12-13,
.image-12-14,
.image-12-15 {
  aspect-ratio: 1;
  height: 50px;
  object-fit: cover;
  width: 50px;
}

.text-370,
.text-562,
.text-655,
.text-769,
.text-952,
.text-1030,
.text-1093,
.text-1315,
.text-1424,
.text-1607,
.text-1644,
.text-1696,
.text-1730,
.text-1913,
.text-2105 {
  letter-spacing: 0.3px;
  line-height: normal;
  white-space: nowrap;
  font-size: 15px;
  user-select: none;
}

.text-371,
.text-563,
.text-656,
.text-770,
.text-953,
.text-1031,
.text-1094,
.text-1316,
.text-1425,
.text-1608,
.text-1645,
.text-1697,
.text-1731,
.text-1914,
.text-2106 {
  letter-spacing: 0.24px;
  line-height: normal;
  white-space: nowrap;
  display: flex;
  align-items: center;
}

/* Новые стили для header варианта */
.group-491--header {
  position: relative !important;
  margin-left: 0 !important;
  gap: 8px;
  padding: 4px;
  border-radius: 50px;
  transition: background-color 0.2s ease;
}

.group-491--header:hover {
  background-color: rgba(0, 0, 0, 0.02);
}

.group-491--header .group-235 {
  height: 40px;
  width: 40px;
}

.group-491--header .image-12-1 {
  height: 40px;
  width: 40px;
}

.group-491--header .text-370 {
  font-size: 14px;
  max-width: 150px;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* Utility классы */
.poppins-medium-black-17px {
  color: #000000;
  font-family: "Poppins", sans-serif;
  font-size: 17px;
  font-weight: 500;
}

/* Responsive */
@media (max-width: 768px) {
  .group-491--header .text-370 {
    display: none;
  }
  
  .group-491--header {
    min-width: auto;
    gap: 4px;
  }
}

@media (max-width: 576px) {
  .group-491--header .text-371 {
    display: none;
  }
  
  .group-491--header {
    padding: 2px;
  }
  
  .group-491--header .group-235 {
    height: 36px;
    width: 36px;
  }
  
  .group-491--header .image-12-1 {
    height: 36px;
    width: 36px;
  }
}
</style>